var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-wire',{attrs:{"can-skip":_vm.newUser},on:{"wire":_vm.onWire,"skip":_vm.onSkip}})}
var staticRenderFns = []

export { render, staticRenderFns }